import { CheckCircleFill, ExclamationCircle } from "react-bootstrap-icons";

import Loading from "@/components/ui/spinner/Loading";

export type TFolderStatusIconState = "pending" | "done" | "failed";

interface IStatusIconProps {
  status: TFolderStatusIconState;
}

function StatusIcon({ status }: IStatusIconProps) {
  if (status === "pending") {
    return <Loading variant="primary" className="flex-shrink-0 mt-2 me-2" />;
  }

  if (status === "done") {
    return (
      <CheckCircleFill
        size={18}
        className="text-success flex-shrink-0 mt-2 me-2"
      />
    );
  }

  return (
    <ExclamationCircle
      size={18}
      className="text-danger flex-shrink-0 mt-2 me-2"
    />
  );
}

export default StatusIcon;
